import React, {Component} from 'react';
import { State } from "./reducer";
import { Dispatch } from "redux";
import { connect, ConnectedProps } from "react-redux";
import MainMenu from './MainMenu';
import Clouddrives from './Clouddrives';
import { Layout } from 'antd';
import Appliances from './Appliances';
import Keys from './Keys';
import Servers from './Servers';
import { INITIAL_SERVER_SETUP_SIZE_STORAGE_KEY, INITIAL_SERVER_SETUP_STORAGE_KEY } from './NewServerStart';
import { RouteComponentProps, withRouter } from 'react-router';


const mapStateToProps = (state: State) => {
    return {

    }
}
  
const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
    }
}
  
const connector = connect(mapStateToProps, mapDispatchToProps);

class Home extends Component<RouteComponentProps & ConnectedProps<typeof connector> >
{
    componentDidMount() {
        const uuid = localStorage.getItem(INITIAL_SERVER_SETUP_STORAGE_KEY);
        const ssize = localStorage.getItem(INITIAL_SERVER_SETUP_SIZE_STORAGE_KEY);
	    if (uuid && ssize) {
            this.props.history.push('/app/payment');
        }
    }

    render() {
        return (
            <div style={{ height: "100%"}}>
                <Layout.Sider style={{height: "100%", position: 'fixed', left: 0}}>
                    <MainMenu />
                </Layout.Sider>
                <Layout className="site-layout" style={{ marginLeft: 200 }}>
                    <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                        <Appliances />
                    </Layout.Content>
                    <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                        <Servers />
                    </Layout.Content>
                    <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                        <Clouddrives />
                    </Layout.Content>
                    <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                        <Keys />
                    </Layout.Content>
                </Layout>
            </div>
        );
    }
}

export default withRouter(connector(Home))